import React from "react";
import { HelpCircle } from "react-feather";

export default function QuesAnswer() {
  const QuesAnswerData = [
    {
      question: "How our HeroAcademi work ?",
      answer:
        "Subcribe to a plan that suits you and browse latest job updates.",
    },
    {
      question: "What is the main benefit of subscription ?",
      answer:
        "Get discounted rates for session booking and longer duration of premium features",
    },
    {
      question: "Is subscription mandatory ?",
      answer:
        "Subscription is mandatory for using premium features",
    },
    {
      question: "Is HeroAcademi safer to use with my account ?",
      answer:
        "Yes, We follow industry standard security measures for protecting your account details.",
    },
  ];
  return (
    <div className="container md:mt-24 mt-16">
      <div className="grid grid-cols-1 pb-8 text-center">
        <h3 className="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">
          Questions & Answers
        </h3>

        <p className="text-slate-400 max-w-xl mx-auto">
        Search all the open positions on the web. Get your own personalized
        job updates.
        </p>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 mt-8 gap-[30px]">
        {QuesAnswerData.map((item, index) => (
          <div className="flex" key={index}>
            <HelpCircle className="h-8 text-indigo-600 me-3"></HelpCircle>
            <div className="flex-1">
              <h5 className="mb-2 text-lg font-semibold">
                {item.question}
                <span className="text-indigo-600"></span>{" "}
              </h5>
              <p className="text-slate-400">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
